import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { SortDirection } from '../../../enums/SortDirection';
import { useCheckDevice } from '../../../hooks/UseCheckDevice';
import { useSortingIndicator } from '../../../hooks/UseSortingIndicator';
import { Icon } from '../../style';

type SortingIndicatorProps = {
  direction: SortDirection;
  onClick: (column: any) => void;
  column: any;
  isVisible: boolean;
};

const SortingIndicator: FC<SortingIndicatorProps> = ({ direction, onClick, column, isVisible }) => {
  const { getColor } = useSortingIndicator();
  const { isMobileDevice } = useCheckDevice();

  const onIconClick = (): void => {
    onClick(column);
  };

  return (
    <>
      {isVisible && (
        <Wrapper isMobileDevice={isMobileDevice} data-testid='sorting-indicator'>
          <Icon
            data-testid='sorting-indicator-arrow-up'
            type='dir-up'
            size={theme.typography.h6}
            color={getColor(direction, 'up')}
            title={''}
            onClick={onIconClick}
          />
          <Icon
            data-testid='sorting-indicator-arrow-down'
            type='dir-down'
            size={theme.typography.h6}
            color={getColor(direction, 'down')}
            title={''}
            onClick={onIconClick}
          />
        </Wrapper>
      )}
    </>
  );
};

export default SortingIndicator;
type WrapperProps = {
  isMobileDevice: boolean;
};

const Wrapper = styled.span<WrapperProps>`
  display: flex;
  flex-direction: column;
  width: 0px;
  height: 20px;
  margin-bottom: 3px;
  padding-right: ${(props) => (props.isMobileDevice ? '20' : '')}px;
  &:hover {
    cursor: pointer;
  }

  > * {
    width: 20px;
  }
`;
